// extracted by mini-css-extract-plugin
export default {"formGroupLabel":"styles_formGroupLabel__GVAJp"};